import React from "react";
import { IconTag } from "@tabler/icons-react";
import { EmojiPicker } from "../common/EmojiPicker";
import { TAG_EMOJIS } from "./tagEmojis";

export interface TagEmojiPickerProps {
  /** Selected emoji; null = the default tag icon. */
  value: string | null;
  onChange: (emoji: string | null) => void;
  disabled?: boolean;
}

/**
 * The shared EmojiPicker configured for appointment tags: the curated
 * TAG_EMOJIS grid with the tag icon as the "Default" (no emoji) choice.
 */
export default function TagEmojiPicker({
  value,
  onChange,
  disabled = false,
}: TagEmojiPickerProps) {
  return (
    <EmojiPicker
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={TAG_EMOJIS}
      defaultIcon={<IconTag size={15} stroke={2} />}
      ariaLabel="Choose tag icon"
    />
  );
}
